__turbopack_context__.v({
  "active": "DocumentSummary-module__3wpM8G__active",
  "container": "DocumentSummary-module__3wpM8G__container",
  "count": "DocumentSummary-module__3wpM8G__count",
  "item": "DocumentSummary-module__3wpM8G__item",
  "label": "DocumentSummary-module__3wpM8G__label",
  "underline": "DocumentSummary-module__3wpM8G__underline",
});
